<template>
  <div class="suite_manage_info">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" v-if="isShowByPermission('/wyms/suite/updateSuite')" @click="toEditSuite">编辑</el-button>
      <el-button size="medium" type="danger" v-if="isShowByPermission('/wyms/suite/deleteSuiteZ')" @click="toDelSuite">删除</el-button>
    </div>
    <div class="suite_info_box" :style="`height: ${windowHeight - 170}px;`">
      <div class="suite_info_content">
        <div class="top_title_box">
          <img class="suite_logo" :src="suiteInfo.logoUrl">
          <div class="suite_title_box">
            <div class="suite_title">{{suiteInfo.name}}</div>
            <div>
              <span>{{suiteTypeList[suiteInfo.suiteType - 1] || '其他'}}</span>
              <span>{{suiteList[suiteInfo.suiteEnvironment - 1]}}</span>
              <span>{{suiteGroupList[suiteInfo.suiteGroups - 1] || '其他'}}</span>
            </div>
          </div>
        </div>
        <div class="suite_content">
          <div class="content_title">基本信息</div>
          <div class="content_box">
            <div class="content_line">
              <div class="desc_title">套件ID</div>
              <div class="desc_content">{{suiteInfo.suiteId}}</div>
            </div>
            <div class="content_line">
              <div class="desc_title">secret</div>
              <div class="desc_content">{{suiteInfo.suiteSecret}}</div>
            </div>
            <div class="content_line">
              <div class="desc_title">Token</div>
              <div class="desc_content">{{suiteInfo.suiteToken}}</div>
            </div>
            <div class="content_line">
              <div class="desc_title">EncodingAESkey</div>
              <div class="desc_content">{{suiteInfo.encodingAESKey}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize'
  import {getSuiteInfo, deleteSuite} from '@/api/suiteSystem'

  export default {
    name: "suiteManageInfo",
    data() {
      return {
        suiteId: this.$route.query.suiteId,
        suiteList: ['通用', '微校+', '成长乐园'],
        suiteGroupList: ['通讯录套件', '基础套件', '独立应用', '行业应用'],
        suiteTypeList: ['应用套件', '通讯录套件', '普通应用', '通讯录应用', '其他', '家校应用'],
        suiteInfo: {}
      }
    },
    mixins: [windowResize],
    created() {
      this.getSuiteInfo();
    },
    methods: {
        isShowByPermission,
      goBack() {
        this.$router.go(-1);
      },
      getSuiteInfo() {
        getSuiteInfo({id: this.suiteId}).then(data => {
          this.suiteInfo = data;
        })
      },
      toEditSuite() {
        this.$router.push({path: 'suiteManageAdd', query: {suiteId: this.suiteId}})
      },
      toDelSuite() {
        this.$confirm("确认要删除该套件吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteSuite({id: this.suiteId}).then(data => {
            this.$message.success('删除成功');
            this.goBack();
          })
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .suite_manage_info{
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .suite_info_box{
      @include scrollBar;
      .suite_info_content{
        width: 810px;
        margin: 0 auto;
        .top_title_box{
          @include clearfix;
          overflow: hidden;
          .suite_logo{
            float: left;
            width: 90px;
            height: 90px;
            margin: 20px;
            border-radius: 4px;
          }
          .suite_title_box{
            float: left;
            width: 660px;
            height: 125px;

            .suite_title{
              height: 30px;
              line-height: 30px;
              margin-top: 22px;
              margin-bottom: 20px;
              font-size: 20px;
              font-weight: bold;
              overflow: hidden;
            }
            span{
              display: inline-block;
              line-height: 20px;
              text-align: center;
              margin-right: 8px;
              padding: 5px 15px;
              background: #e5e5e5;
              border-radius: 2px;
            }
          }
        }
        .suite_content{
          overflow: hidden;
          .content_title{
            height: 20px;
            line-height: 20px;
            margin-top: 15px;
            margin-left: 15px;
            padding-left: 8px;
            border-left: 4px solid #409EFF;
          }
          .content_box{
            .content_line{
              @include clearfix;
              margin-top: 15px;
              line-height: 20px;
              overflow: hidden;

              .desc_title{
                float: left;
                width: 17%;
                margin-right: 3%;
                text-align: right;
              }
              .desc_content{
                float: left;
                width: 80%;
                word-break: break-all;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/suiteSystem/suiteManage/suiteManageInfo.vue